module.exports = __webpack_public_path__ + "public/img/horizontal_logo.6c9a91a0.svg";